import { Component } from 'react';
import { Control, Errors } from 'forms/rrf';
import { Row, Col, FormGroup, FormControl, FormLabel } from 'react-bootstrap';
import { validators } from '../../../utils/validators';

class RequiredPointRedemptionDate extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {
    const { model, label } = this.props;

    return (
      <div>
        <Row>
          <Col lg={12} className="point-redemption-date-col">
            <FormGroup controlId={model} className={`form-group${this.state[model] ? ` has-${this.state[model]}` : ''}`}>
              <FormLabel>
                {`${label} dd/mm*`}
              </FormLabel>
              <Control
                model={`.${model}`}
                validators={{ required: validators.required(this.updateErrors, model) }}
                placeholder="dd/mm"
                pattern="\d\d/\d\d"
                component={FormControl}
              />
              <Errors
                show={{
                  touched: true,
                  focus: false
                }}
                className="errors"
                model={`.${model}`}
                messages={{
                  required: 'This field is required',
                  patternMismatch: 'Value does not match the required pattern'
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

export default RequiredPointRedemptionDate;
